module.exports = __webpack_public_path__ + "static/media/AeroGCSEnterprise.ca436089.svg";